export default "__VITE_ASSET__C4o2C96g__"